
import Vue from "vue";
import msDataProvider from "../services/msDataProvider";
import ErrorCard from "@/components/partials/ErrorCard.vue";

export default Vue.extend({
  components: {ErrorCard},
  props: [
    "title",
    "buttonLabel",
    "buttonIcon",
    "buttonCondition",
    "errorFilter",
    "buttonClasses"
  ],
  data() {
    return {
      showDetailError: false,
      valid: false,
      loading: false,
      isSystemError: false,
      error: "",
      binding: {},
      alertShown: false,
    };
  },
  methods: {
    set(key, value) {
      this.$emit("update:" + key, value);
    },
    alertClose() {
      this.alertShown = false;
    },
    showDetail() {
      this.alertShown = true;
    },
    async submit() {
      this.error = "";
      this.loading = true;
      this.$emit("submit", (err, isSystemError) => {
        this.error = err;
        this.isSystemError = isSystemError
        this.loading = false;
      });
    },
  },
  created() {
    msDataProvider.bindDataMany(["setting"], this.binding, this, null, this);
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
});
